/* THIS (.ts) FILE IS GENERATED BY TypedSignalR.Client.TypeScript */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import type { HubConnection, IStreamResult } from '@microsoft/signalr';
import type { IBrowserEventHub } from './Platform.Eventing.Contracts.BrowserEvents';
import type { IAgentBrowserEvents } from './Platform.AgentIntegration.Agents.AgentRegistered.BrowserEvents';
import type { IDiscoveryProgressBrowserEvents } from './Platform.AgentIntegration.DiscoveryProgress.BrowserEvents';
import type { IHierarchyBrowserEvents } from './Platform.Hierarchy.BrowserEvents';
import type { IIdentityBrowserEvents } from './Platform.Identity.BrowserEvents';
import type { INotificationBrowserEvents } from './Platform.Notification.Contracts.BrowserEvents';
import type { BrowserEventChannel } from '../Platform.Eventing.Contracts.BrowserEvents';
import type { AgentRegisteredEvent } from '../Platform.AgentIntegration.Agents.AgentRegistered.BrowserEvents';
import type { DiscoveryProgressChangedEvent } from '../Platform.AgentIntegration.DiscoveryProgress.BrowserEvents';
import type { EntityChangedEvent } from '../Platform.Hierarchy.BrowserEvents';


// components

export type Disposable = {
    dispose(): void;
}

export type HubProxyFactory<T> = {
    createHubProxy(connection: HubConnection): T;
}

export type ReceiverRegister<T> = {
    register(connection: HubConnection, receiver: T): Disposable;
}

type ReceiverMethod = {
    methodName: string,
    method: (...args: any[]) => void
}

class ReceiverMethodSubscription implements Disposable {

    public constructor(
        private connection: HubConnection,
        private receiverMethod: ReceiverMethod[]) {
    }

    public readonly dispose = () => {
        for (const it of this.receiverMethod) {
            this.connection.off(it.methodName, it.method);
        }
    }
}

// API

export type HubProxyFactoryProvider = {
    (hubType: "IBrowserEventHub"): HubProxyFactory<IBrowserEventHub>;
}

export const getHubProxyFactory = ((hubType: string) => {
    if(hubType === "IBrowserEventHub") {
        return IBrowserEventHub_HubProxyFactory.Instance;
    }
}) as HubProxyFactoryProvider;

export type ReceiverRegisterProvider = {
    (receiverType: "IAgentBrowserEvents"): ReceiverRegister<IAgentBrowserEvents>;
    (receiverType: "IDiscoveryProgressBrowserEvents"): ReceiverRegister<IDiscoveryProgressBrowserEvents>;
    (receiverType: "IHierarchyBrowserEvents"): ReceiverRegister<IHierarchyBrowserEvents>;
    (receiverType: "IIdentityBrowserEvents"): ReceiverRegister<IIdentityBrowserEvents>;
    (receiverType: "INotificationBrowserEvents"): ReceiverRegister<INotificationBrowserEvents>;
}

export const getReceiverRegister = ((receiverType: string) => {
    if(receiverType === "IAgentBrowserEvents") {
        return IAgentBrowserEvents_Binder.Instance;
    }
    if(receiverType === "IDiscoveryProgressBrowserEvents") {
        return IDiscoveryProgressBrowserEvents_Binder.Instance;
    }
    if(receiverType === "IHierarchyBrowserEvents") {
        return IHierarchyBrowserEvents_Binder.Instance;
    }
    if(receiverType === "IIdentityBrowserEvents") {
        return IIdentityBrowserEvents_Binder.Instance;
    }
    if(receiverType === "INotificationBrowserEvents") {
        return INotificationBrowserEvents_Binder.Instance;
    }
}) as ReceiverRegisterProvider;

// HubProxy

class IBrowserEventHub_HubProxyFactory implements HubProxyFactory<IBrowserEventHub> {
    public static Instance = new IBrowserEventHub_HubProxyFactory();

    private constructor() {
    }

    public readonly createHubProxy = (connection: HubConnection): IBrowserEventHub => {
        return new IBrowserEventHub_HubProxy(connection);
    }
}

class IBrowserEventHub_HubProxy implements IBrowserEventHub {

    public constructor(private connection: HubConnection) {
    }

    public readonly whoAmI = async (): Promise<(string | undefined)> => {
        return await this.connection.invoke("WhoAmI");
    }

    public readonly subscribeToChannel = async (channel: BrowserEventChannel): Promise<void> => {
        return await this.connection.invoke("SubscribeToChannel", channel);
    }

    public readonly unsubscribeFromChannel = async (channel: BrowserEventChannel): Promise<void> => {
        return await this.connection.invoke("UnsubscribeFromChannel", channel);
    }
}


// Receiver

class IAgentBrowserEvents_Binder implements ReceiverRegister<IAgentBrowserEvents> {

    public static Instance = new IAgentBrowserEvents_Binder();

    private constructor() {
    }

    public readonly register = (connection: HubConnection, receiver: IAgentBrowserEvents): Disposable => {

        const __agentRegistered = (...args: [AgentRegisteredEvent]) => receiver.agentRegistered(...args);

        connection.on("AgentRegistered", __agentRegistered);

        const methodList: ReceiverMethod[] = [
            { methodName: "AgentRegistered", method: __agentRegistered }
        ]

        return new ReceiverMethodSubscription(connection, methodList);
    }
}

class IDiscoveryProgressBrowserEvents_Binder implements ReceiverRegister<IDiscoveryProgressBrowserEvents> {

    public static Instance = new IDiscoveryProgressBrowserEvents_Binder();

    private constructor() {
    }

    public readonly register = (connection: HubConnection, receiver: IDiscoveryProgressBrowserEvents): Disposable => {

        const __discoveryProgressChanged = (...args: [DiscoveryProgressChangedEvent]) => receiver.discoveryProgressChanged(...args);

        connection.on("DiscoveryProgressChanged", __discoveryProgressChanged);

        const methodList: ReceiverMethod[] = [
            { methodName: "DiscoveryProgressChanged", method: __discoveryProgressChanged }
        ]

        return new ReceiverMethodSubscription(connection, methodList);
    }
}

class IHierarchyBrowserEvents_Binder implements ReceiverRegister<IHierarchyBrowserEvents> {

    public static Instance = new IHierarchyBrowserEvents_Binder();

    private constructor() {
    }

    public readonly register = (connection: HubConnection, receiver: IHierarchyBrowserEvents): Disposable => {

        const __capabilitiesChanged = () => receiver.capabilitiesChanged();
        const __entityChanged = (...args: [EntityChangedEvent]) => receiver.entityChanged(...args);

        connection.on("CapabilitiesChanged", __capabilitiesChanged);
        connection.on("EntityChanged", __entityChanged);

        const methodList: ReceiverMethod[] = [
            { methodName: "CapabilitiesChanged", method: __capabilitiesChanged },
            { methodName: "EntityChanged", method: __entityChanged }
        ]

        return new ReceiverMethodSubscription(connection, methodList);
    }
}

class IIdentityBrowserEvents_Binder implements ReceiverRegister<IIdentityBrowserEvents> {

    public static Instance = new IIdentityBrowserEvents_Binder();

    private constructor() {
    }

    public readonly register = (connection: HubConnection, receiver: IIdentityBrowserEvents): Disposable => {

        const __permissionsChanged = () => receiver.permissionsChanged();

        connection.on("PermissionsChanged", __permissionsChanged);

        const methodList: ReceiverMethod[] = [
            { methodName: "PermissionsChanged", method: __permissionsChanged }
        ]

        return new ReceiverMethodSubscription(connection, methodList);
    }
}

class INotificationBrowserEvents_Binder implements ReceiverRegister<INotificationBrowserEvents> {

    public static Instance = new INotificationBrowserEvents_Binder();

    private constructor() {
    }

    public readonly register = (connection: HubConnection, receiver: INotificationBrowserEvents): Disposable => {

        const __notificationsChanged = () => receiver.notificationsChanged();

        connection.on("NotificationsChanged", __notificationsChanged);

        const methodList: ReceiverMethod[] = [
            { methodName: "NotificationsChanged", method: __notificationsChanged }
        ]

        return new ReceiverMethodSubscription(connection, methodList);
    }
}
